interface ShowAllPhotosButtonProps {
    onClick: () => void;
    className?: string;
}

export default function ShowAllPhotosButton({ onClick, className = "" }: ShowAllPhotosButtonProps) {
    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation(); // Prevent event bubbling to parent image container
        onClick();
    };

    return (
        <button
            type="button"
            className={`homerunner-gallery-show-all-photos-button absolute appearance-none border-0 bg-card text-card-foreground px-3 py-2 rounded-lg shadow-lg hover:shadow-xl transition-shadow cursor-pointer flex items-center gap-2 text-sm font-medium z-10 ${className}`}
            onClick={handleClick}
        >
            <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="homerunner-gallery-show-all-photos-icon w-4 h-4"
            >
                <rect x="3" y="3" width="7" height="7"></rect>
                <rect x="14" y="3" width="7" height="7"></rect>
                <rect x="14" y="14" width="7" height="7"></rect>
                <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
            <span className="homerunner-gallery-show-all-photos-text">Show all photos</span>
        </button>
    );
}
